<template>
  <div class="modal-column">
    <div class="flex-1 p-20px">
      <Form ref="form" :model="formData" :rules="{}" mode="block">
        <FormItem label="摘要" prop="digest" required>
          <Textarea row="3" v-model="formData.digest"/>
        </FormItem>
        <div class="inline-form-item">
          <FormItem label="转出账户" prop="outAccountId" required>
            <Select :deletable="false" :datas="accountList" keyName="id" titleName="name" v-model="formData.outAccountId">
              <template #show="{value}">{{ value.code }} - {{ value.name }}</template>
              <template #item="{item}">{{ item.code }} - {{ item.name }}</template>
            </Select>
          </FormItem>
          <FormItem label="转入账户" prop="inAccountId" required>
            <Select :deletable="false" :datas="accountList" keyName="id" titleName="name" v-model="formData.inAccountId">
              <template #show="{value}">{{ value.code }} - {{ value.name }}</template>
              <template #item="{item}">{{ item.code }} - {{ item.name }}</template>
            </Select>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="转账日期" prop="transferDate" required>
            <DatePicker v-model="formData.transferDate" :clearable="false"/>
          </FormItem>
          <FormItem label="转账金额" prop="amount" required>
            <Input type="text" v-model="formData.amount"/>
          </FormItem>
        </div>
        <FormItem label="备注" prop="remark">
          <Textarea row="3" v-model="formData.remark"/>
        </FormItem>
      </Form>
    </div>
    <div class="modal-column-between">
      <Button @click="$emit('close')">取消</Button>
      <div>
        <Button v-if="!formData.id" @click="submit(true)" :loading="loading">保存并新增</Button>
        <Button color="primary" @click="submit()" :loading="loading">{{ formData.id ? '更新' : '保存' }}</Button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "InternalTransferForm"
}
</script>

<script setup>

import {reactive, ref, defineEmits, defineProps, toRefs} from "vue";
import CashierTransfer from "@/api/CashierTransfer";
import {CopyObj} from "@/js/common/utils";
import {useStore} from "vuex";
import manba from "manba";

const store = useStore();
const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate);
const endDate = ref(currentAccountDate.endOf(manba.MONTH).format());

const emits = defineEmits(['success', 'close']);
const props = defineProps(['entity', 'accountList']);

const {entity, accountList} = toRefs(props);

const loading = ref(false);
const form = ref(null);

const formData = reactive({
  id: null,
  digest: "资金内部调拨",
  transferDate: endDate.value,
  inAccountId: null,
  outAccountId: null,
  amount: null,
  remark: null,
})

const submit = (next = false) => {
  let validResult = form.value.valid();
  if (validResult.result) {
    loading.value = true;

    CashierTransfer.save(formData).then(() => {
      if (next) {
        formData.amount = null;
        emits('reload')
      } else {
        emits('success')
      }
    }).finally(() => loading.value = false)
  }
}

CopyObj(formData, entity.value)
</script>
